import { useAppDispatch, useAppSelector } from "@app/store";
import { useCallback } from "react";
import { createAppeal, getMerchantPayoutOrders, uploadPayOutReceipt } from "./slice";
import { MerchantOrderPayoutRequest } from "./api";
import { CreateAppealRequest } from "@features/appeals/api";

export const useMerchantPayoutOrders = () => {
  const state = useAppSelector((state) => state.merchantPayoutOrders);
  const dispatch = useAppDispatch();

  const getMerchantPayoutOrdersHandler = useCallback(
    (data: MerchantOrderPayoutRequest) =>
      dispatch(getMerchantPayoutOrders({ data })),
    [dispatch]
  );
  const uploadReceiptHandler = useCallback(
    (orderId: string, file: FileList) =>
      dispatch(uploadPayOutReceipt({ orderId, file })),
    [dispatch]
  );
  const createAppealHandler = useCallback(
    (data: CreateAppealRequest) =>
      dispatch(createAppeal({ data })),
    [dispatch]
  );

  return {
    state,
    getMerchantPayoutOrders: getMerchantPayoutOrdersHandler,
    uploadReceipt: uploadReceiptHandler,
    createAppeal: createAppealHandler,
  };
};
